const TOGGLED_CLASS = 'scroll-helper--down';

export function initScrollToNextStopButton(button: HTMLElement) {

	button.addEventListener('click', (e) => {
		e.preventDefault();
		goToClosestBelow(button);
	})

}

export function initScrollHelper(wrapper: HTMLDivElement, footer: HTMLDivElement) {

	let button = wrapper.querySelector('[data-scroll-helper-button]')

	if (button) {
		wrapper.addEventListener('click', (e) => {
			e.preventDefault();
			go(wrapper);
		});
	}


	if (footer) {
		let observer = new IntersectionObserver(
			(entries) => {
				let isDown = entries[0]?.isIntersecting;
				wrapper.classList.toggle(TOGGLED_CLASS, isDown);
			},
			{
				threshold: 0.2
			}
		);

		observer.observe(footer);
	}


}


function go(wrapper: HTMLDivElement) {

	if (wrapper.classList.contains(TOGGLED_CLASS)) {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
		return;
	}

	let stops = document.querySelectorAll<HTMLDivElement>('.c-scroll-stop');
	let winPos = window.scrollY;
	let winH = window.innerHeight;
	let closestNextStop = Infinity;

	stops.forEach(
		(stop) => {
			let pos = stop.offsetTop;
			if (pos > winPos) {
				if (pos < closestNextStop) {
					closestNextStop = pos;
				}
			}
		}
	)

	if (!closestNextStop || closestNextStop === Infinity) {
		closestNextStop = document.body.clientHeight;
	}

	if (closestNextStop) {
		window.scrollTo({
			top: closestNextStop,
			behavior: 'smooth'
		})
	}

}

function goToClosestBelow(source: HTMLElement) {

	let stops = document.querySelectorAll<HTMLDivElement>('.c-scroll-stop');
	let sourceY = source.getBoundingClientRect().y + window.scrollY;
	let closestNextStop = Infinity;

	stops.forEach(
		(stop) => {
			let pos = stop.offsetTop;
			if (pos > sourceY && pos < closestNextStop) {
				closestNextStop = pos;
			}
		}
	)

	if (!closestNextStop) {
		closestNextStop = document.body.clientHeight;
	}

	if (closestNextStop) {
		window.scrollTo({
			top: closestNextStop,
			behavior: 'smooth'
		})
	}

}
